ScoreTrekBattle.Tournament.Edit = (function() {
    var _this, STATUS, CONFIG;

    STATUS = {};

    CONFIG = {
        validation: {
            'presetId': {
                mandatory: true,
            },
            'title': {
                mandatory: true,
            },
            'description': {
                mandatory: true,
            },
            'dateTimeTournamentDate': {
                mandatory: true,
            },
            'dateTimeTournamentTime': {
                mandatory: true,
            },
            'dateTimeRegistrationDate': {
                mandatoryIfChecked: [
                    'hasRegistration'
                ]
            },
            'dateTimeRegistrationTime': {
                mandatoryIfChecked: [
                    'hasRegistration'
                ]
            },
            'dateTimeWithdrawLimitDate': {
                mandatoryIfChecked: [
                    'hasWithdrawLimit'
                ]
            },
            'dateTimeWithdrawLimitTime': {
                mandatoryIfChecked: [
                    'hasWithdrawLimit'
                ]
            },
            'waitlistLimit': {
                mandatoryIfChecked:  [
                    'hasWaitlist'
                ],
                range: {
                    min: 1,
                    max: 100
                }
            },
            'locationStreet': {
                mandatory: true,
            },
            'locationZip': {
                mandatory: true,
            },
            'locationCity': {
                mandatory: true,
            }
        },
        dateTimeValidation: {
            'hasRegistration': 'dateTimeRegistration',
            'hasWithdrawLimit': 'dateTimeWithdrawLimit'
        },
        dateTimeFields: [
            'dateTimeTournament',
            'dateTimeRegistration',
            'dateTimeWithdrawLimit'
        ],
        dateTimeAutofill: [
            'dateTimeRegistration',
            'dateTimeWithdrawLimit'
        ],
        previewOptional: [
            'seriesId',
            'nextTournamentId',
            'entryFee',
            'approvalNumber',
            'dressCode'
        ],
        // Season is an independent top-level dimension, no longer part of the group
        // picker cascade — the picker is scoped to the matchday's chosen season.
        leagueFilterOrder: ['countryId', 'federationId', 'divisionId', 'leagueId', 'groupId'],
        // Shared with the matchday plan list: pre-fills a new matchday's season.
        matchdaySeasonStorageKey: 'ScoreTrekBattle.League.Matchday.Season',
        // Sentinel option value that switches the opponent picker to free-text entry.
        opponentCustomValue: '__custom__',
        // Sentinel option value that opens the squad editor instead of picking.
        ownSquadAddValue: '__add__',
        validationLeague: {
            'seasonId': {
                mandatory: true,
            },
            'dateTimeMatchdayDate': {
                mandatory: true,
            },
            'dateTimeMatchdayTime': {
                mandatory: true,
            },
            'ownSquadId': {
                mandatory: true,
            },
            'opponentSquadId': {
                mandatory: true,
            },
            'locationStreet': {
                mandatory: true,
            },
            'locationZip': {
                mandatory: true,
            },
            'locationCity': {
                mandatory: true,
            }
        }
    };

    function resetStatus() {
        STATUS.active = false;
        STATUS.mode = 'tournament';
        STATUS.isNew = true;
        STATUS.isLimitedEdit = false;
        STATUS.limitedEditableFields = [];
        STATUS.tournamentId = '';
        STATUS.data = {};
        STATUS.club = null;
        STATUS.presets = {};
        STATUS.pointsMaps = {};
        STATUS.series = {};
        STATUS.tournaments = {};
        STATUS.clubs = {};
        STATUS.ownSquads = {};
        STATUS.opponentOptionsSignature = null;
        STATUS.opponentGroupId = null;
        STATUS.seasons = [];
        STATUS.currentSeasonId = '';
        STATUS.leagueReady = false;
        STATUS.pickerSeasonId = '';
        STATUS.leagueCascadeAttached = false;
        STATUS.leagueFilterRequestId = 0;
        STATUS.view = null;
        STATUS.$view = null;
        STATUS.form = null;
    }
    resetStatus();

    function isLeagueMode() {
        return STATUS.mode === 'league';
    }

    function onViewRenderCreate() {
        return new Promise(function(resolve) {
            STATUS.mode = 'tournament';
            STATUS.tournamentId = '';

            ScoreTrekBattle.View.loading('Tournament.Edit.onViewRenderCreate', true);
            onViewRender().then(resolve).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.onViewRenderCreate', false);
            });
        });
    }

    function onViewRenderEdit(tournamentId) {
        return new Promise(function(resolve) {
            STATUS.mode = 'tournament';
            STATUS.tournamentId = tournamentId || '';

            ScoreTrekBattle.View.loading('Tournament.Edit.onViewRenderEdit', true);
            onViewRender().then(resolve).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.onViewRenderEdit', false);
            });
        });
    }

    function onViewRenderMatchdayCreate() {
        return new Promise(function(resolve) {
            STATUS.mode = 'league';
            STATUS.tournamentId = '';

            ScoreTrekBattle.View.loading('Tournament.Edit.onViewRenderMatchdayCreate', true);
            onViewRender().then(resolve).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.onViewRenderMatchdayCreate', false);
            });
        });
    }

    function onViewRenderMatchdayEdit(matchdayId) {
        return new Promise(function(resolve) {
            STATUS.mode = 'league';
            STATUS.tournamentId = matchdayId || '';

            ScoreTrekBattle.View.loading('Tournament.Edit.onViewRenderMatchdayEdit', true);
            onViewRender().then(resolve).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.onViewRenderMatchdayEdit', false);
            });
        });
    }

    function onViewRender() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.updateMenu('/tournament/create');
            ScoreTrekBattle.Template.render('tournament/edit/form', {

            }).then(view => {
                STATUS.active = true;
                STATUS.view = view;
                STATUS.$view = STATUS.view.$view;
                applyMode();
                if (isLeagueMode()) {
                    STATUS.$view.find('[data-id="backToPresets"]').hide();
                    STATUS.$view.find('[data-id="backToTournament"]').hide();
                    STATUS.$view.find('[data-id="backToList"]')
                        .attr('href', '/league/plan')
                        .find('[data-i18n="tabs/tournaments"]').text(__i18n('tabs/league')).removeAttr('data-i18n');
                    STATUS.$view.find('[data-id="backToList"]').show();
                } else if (STATUS.tournamentId) {
                    STATUS.$view.find('[data-id="backToPresets"]').hide();
                    STATUS.$view.find('[data-id="backToList"]').attr('href', `/tournament/plan/${STATUS.tournamentId}`);
                    STATUS.$view.find('[data-id="backToTournament"]').attr('href', `/tournament/details/${STATUS.tournamentId}`);
                } else {
                    STATUS.$view.find('[data-id="backToPresets"]').show();
                    STATUS.$view.find('[data-id="backToList"]').hide();
                    STATUS.$view.find('[data-id="backToTournament"]').hide();
                }
                try {
                    STATUS.form = STATUS.view.forms.scheduleTournament;
                } catch(e) {
                    console.warn(e);
                    STATUS.form = null;
                }
                prepareForm().then(() => {;
                    resolve(STATUS.$view);
                });
            });
        });
    }

    function onViewLoad() {
        STATUS.active = true;
        addEventListeners();
        renderData();
        if (isLeagueMode()) {
            initLeagueControls();
        }
    }

    function onViewLoadCreate(presetId) {
        return new Promise(function(resolve, reject) {
            STATUS.isNew = true;
            updateTitle();
            ScoreTrekBattle.View.loading('Tournament.Edit.onViewLoadCreate', true);
            Api.request('/battle/tournament/preset/load', {id: presetId}).then(result => {
                STATUS.club = (result.preset && result.preset.club) ? result.preset.club : getClub();
                STATUS.data = getInitialData(result.preset);

                STATUS.isLimitedEdit = false;

                onViewLoad();
                resolve();
            }).catch(error => {
                console.error(error);
                if (error && error.message) {
                    chmDialog.error(error);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.onViewLoadCreate', false);
            });
        });
    }

    function onViewLoadEdit(tournamentId, presetId) {
        return new Promise(function(resolve, reject) {
            STATUS.isNew = false;
            updateTitle();
            ScoreTrekBattle.View.loading('Tournament.Edit.onViewLoadEdit', true);
            Api.request('/battle/tournament/load', {id: tournamentId}).then(result => {
                STATUS.club = result.tournament.club;
                STATUS.data = result.tournament;

                STATUS.isLimitedEdit = !!result.isLimitedEdit;
                STATUS.limitedEditableFields = result.editableFields || [];

                if (presetId) {
                    STATUS.data.presetId = presetId;
                }

                onViewLoad();
                resolve();
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.onViewLoadEdit', false);
            });
        });
    }

    function onViewLoadMatchdayCreate() {
        return new Promise(function(resolve) {
            STATUS.isNew = true;
            updateTitle();
            STATUS.club = getClub();
            STATUS.data = getInitialMatchdayData();
            STATUS.isLimitedEdit = false;
            onViewLoad();
            resolve();
        });
    }

    function onViewLoadMatchdayEdit(matchdayId) {
        return new Promise(function(resolve, reject) {
            STATUS.isNew = false;
            updateTitle();
            ScoreTrekBattle.View.loading('Tournament.Edit.onViewLoadMatchdayEdit', true);
            Api.request('/battle/league/matchday/load', {id: matchdayId}).then(result => {
                STATUS.club = result.matchday.club || getClub();
                STATUS.data = result.matchday;
                // Frontend visibility widget mirrors the model's isPublic field.
                STATUS.data.isPublicMatchday = !!STATUS.data.isPublic;
                STATUS.isLimitedEdit = false;
                onViewLoad();
                resolve();
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.onViewLoadMatchdayEdit', false);
            });
        });
    }

    function getInitialMatchdayData() {
        var club, data;

        club = getClub();

        data = {
            id: '',
            clubId: '',
            modified: null,
            status: 'scheduled',
            title: '',
            intro: '',
            description: '',
            countryId: '',
            federationId: '',
            // Pre-filled from the plan list's remembered season; validated and
            // defaulted against the available seasons in initLeagueControls.
            seasonId: localStorage.getItem(CONFIG.matchdaySeasonStorageKey) || '',
            divisionId: '',
            leagueId: '',
            groupId: '',
            groupLabel: '',
            ownSquadId: '',
            opponentSquadId: '',
            opponentSquadName: '',
            // Zusatz zum abgeleiteten Titel — der Spieltag hat keinen eigenen
            // Namen, hierueber wird eine Begegnung von einer gleichnamigen
            // unterscheidbar (etwa "COPY 1" nach dem Duplizieren).
            titleSuffix: '',
            isPublic: true,
            isPublicMatchday: true,
            timeZone: DateTime.getCurrentTimeZone(),
            locationStreet: club ? (club.address ? `${club.address.street} ${club.address.number}`.trim() : club.street) : '',
            locationZip: club ? (club.address ? club.address.zip : club.zip) : '',
            locationCity: club ? (club.address ? club.address.city : club.city) : '',
            dateTimeMatchdayDate: DateTime.getCurrentDateString(),
            dateTimeMatchdayTime: DateTime.getCurrentTimeString(false, true)
        };

        return data;
    }

    function initLeagueControls() {
        // Populate the season field and both team pickers, then restore the saved
        // selection. set() does not emit a change event, so neither the group is
        // auto-adopted nor cleared here (that only happens on explicit user picks).
        STATUS.leagueReady = false;

        Promise.all([loadSeasons(), loadOwnSquads()]).then(() => {
            restoreSeasonSelection();

            if (STATUS.data.ownSquadId) {
                STATUS.form.controls.ownSquadId.set(STATUS.data.ownSquadId);
            }

            return loadOpponentSquads(STATUS.data.opponentSquadId || '');
        }).then(() => {
            if (STATUS.data.opponentSquadId) {
                STATUS.form.controls.opponentSquadId.set(STATUS.data.opponentSquadId);
            } else if (String(STATUS.data.opponentSquadName || '').trim()) {
                STATUS.form.controls.opponentSquadId.set(CONFIG.opponentCustomValue);
                STATUS.form.controls.opponentSquadName.set(STATUS.data.opponentSquadName);
            }

            updateOpponentAvailability();
            updateOpponentCustomVisibility(true);

            // From here on, an explicit season change clears the group.
            STATUS.leagueReady = true;
        });

        updateGroupDisplay();
    }

    // Season field — the root of the league hierarchy, newest first. Everything
    // below (federation, division, league, group, squad) is resolved within it.
    function loadSeasons() {
        return new Promise(function(resolve) {
            Api.request('/battle/league/seasons').then(result => {
                STATUS.seasons = result.list || [];
                STATUS.currentSeasonId = result.currentId || '';
                STATUS.form.controls.seasonId.setOptions(DataHandler.arrayToOptions(STATUS.seasons, 'id', 'name'));
            }).catch(ignore => {
            }).finally(resolve);
        });
    }

    // Keeps the matchday's season valid: on edit the stored season, on create the
    // pre-filled one, falling back to the season flagged as current.
    function restoreSeasonSelection() {
        var isValid;

        isValid = STATUS.seasons.some(season => season.id === STATUS.data.seasonId);

        if (!isValid) {
            STATUS.data.seasonId = STATUS.currentSeasonId
                || (STATUS.seasons.length ? STATUS.seasons[0].id : '');
        }

        // set() does not fire change → onMatchdaySeasonChange won't clear the group.
        STATUS.form.controls.seasonId.set(STATUS.data.seasonId);
    }

    // An explicit season change invalidates the group and both squad picks — a
    // group and a squad each exist only inside one season. They are cleared and
    // the squad lists reloaded for the newly chosen season.
    function onMatchdaySeasonChange() {
        var newSeason;

        if (!STATUS.leagueReady) {
            return;
        }

        newSeason = STATUS.form.controls.seasonId.get();

        if (newSeason === STATUS.data.seasonId) {
            return;
        }

        STATUS.data.seasonId = newSeason;

        if (STATUS.data.groupId) {
            clearGroupSelection();
        }

        clearSquadSelection();

        loadOwnSquads();
    }

    // Drops both squad picks, including a free-text opponent designation: they
    // refer to the previous season and cannot carry over.
    function clearSquadSelection() {
        STATUS.data.ownSquadId = '';
        STATUS.data.opponentSquadId = '';
        STATUS.data.opponentSquadName = '';

        STATUS.form.controls.ownSquadId.set('');
        STATUS.form.controls.opponentSquadId.set('');
        STATUS.form.controls.opponentSquadName.set('');

        updateOpponentCustomVisibility();
    }

    function clearGroupSelection() {
        CONFIG.leagueFilterOrder.forEach(filterKey => {
            STATUS.data[filterKey] = '';
        });

        STATUS.data.groupLabel = '';

        updateGroupDisplay();
    }

    // ── Group picker dialog ──────────────────────────────
    // The league hierarchy (country → group) is chosen in a modal cascade that
    // writes a single groupId onto STATUS.data. The derived country/federation/
    // division/league values are kept alongside it only to restore the cascade
    // when the dialog is re-opened. The season is fixed to the matchday's chosen
    // season and injected into every cascade request (STATUS.pickerSeasonId).

    function openGroupPicker() {
        // The group picker is scoped to a season — require one first.
        if (!String(STATUS.data.seasonId || '').trim()) {
            chmDialog.error('matchday/season/required');
            return;
        }

        ScoreTrekBattle.Template.render('tournament/edit/groupPicker').then(pickerView => {
            var controls, restore;

            controls = pickerView.controls;

            STATUS.pickerSeasonId = String(STATUS.data.seasonId || '').trim();

            restore = {};
            CONFIG.leagueFilterOrder.forEach(filterKey => {
                restore[filterKey] = STATUS.data[filterKey] || '';
            });

            attachPickerCascade(controls);
            loadPickerFilters(controls, '', restore);

            chmDialog({
                title: __i18n('matchday/league/dialog/title'),
                content: pickerView.$view,
                isPersistant: true,
                buttons: [
                    {
                        action: () => {
                            applyGroupSelection(controls);
                        },
                        label: __i18n('button/apply'),
                        primary: true
                    },
                    {
                        label: __i18n('button/cancel')
                    }
                ]
            });
        });
    }

    function applyGroupSelection(controls) {
        var groupId;

        groupId = String(controls.groupId.get() || '').trim();

        if (!groupId) {
            CONFIG.leagueFilterOrder.forEach(filterKey => {
                STATUS.data[filterKey] = '';
            });
            STATUS.data.groupLabel = '';
        } else {
            CONFIG.leagueFilterOrder.forEach(filterKey => {
                STATUS.data[filterKey] = String(controls[filterKey].get() || '').trim();
            });
            STATUS.data.groupLabel = buildGroupLabel(controls);
        }

        updateGroupDisplay(true);
    }

    function buildGroupLabel(controls) {
        function optionText(filterKey) {
            var text;
            text = String(controls[filterKey].$view.find('select option:selected').text() || '').trim();
            return /^--.*--$/.test(text) ? '' : text;
        }

        return CONFIG.leagueFilterOrder.filter(filterKey => {
            return (filterKey !== 'countryId');
        }).map(optionText).filter(Boolean).join(' · ');
    }

    function reloadOpponentsForGroup(keepSelection) {
        var opponentSquadId;

        opponentSquadId = keepSelection ? STATUS.form.controls.opponentSquadId.get() : '';

        loadOpponentSquads(opponentSquadId).then(() => {
            if (opponentSquadId) {
                STATUS.form.controls.opponentSquadId.set(opponentSquadId);
                updateOpponentCustomVisibility(true);
            }
        });
    }

    function updateGroupDisplay(keepSquads) {
        var label;

        if (!STATUS.$view) {
            return;
        }

        label = STATUS.data.groupLabel || '';

        label = label ? __escapeHTML(label) : `<i class="color-white-60"><i class="fa-solid fa-circle-info"></i> ${__i18n('matchday/league/none')}</i>`;

        STATUS.$view.find('[data-id="selectedGroupLabel"]').html(label);
        STATUS.$view.find('[data-id="selectedGroup"]').attr('data-empty', label ? 'no' : 'yes');

        if (STATUS.leagueReady && (matchdayGroupId() !== STATUS.opponentGroupId)) {
            reloadOpponentsForGroup(keepSquads === true);
        }
    }

    // Home team picker — the club's own squads of the chosen season. A squad
    // belongs to exactly one season, so the season scopes this list.
    function loadOwnSquads() {
        return new Promise(function(resolve) {
            Api.request('/battle/squads', {seasonId: STATUS.data.seasonId || ''}).then(result => {
                var list;

                list = result.list || [];
                STATUS.ownSquads = DataHandler.arrayToAssoc(list, 'id');

                STATUS.form.controls.ownSquadId.setOptions(
                    buildOwnSquadOptions(list),
                    {'': `-- ${__i18n('form/options/ownSquad/none')} --`}
                );
            }).catch(ignore => {
            }).finally(resolve);
        });
    }

    function buildOwnSquadOptions(list) {
        var groups, order, options;

        groups = {};
        order = [];

        list.forEach(squad => {
            var key;

            key = `${squad.federationId || ''}|${squad.divisionId || ''}`;

            if (!groups.hasOwnProperty(key)) {
                groups[key] = {
                    label: squadGroupLabel(squad),
                    html: buildSquadGroupHtml(squad),
                    options: {}
                };
                order.push(key);
            }

            groups[key].options[squad.id] = squadOption(
                squad.label,
                squad.leagueLabel,
                (squad.club || {}).thumbnail || (squad.club || {}).logo || ''
            );
        });

        options = order.map(key => {
            return groups[key];
        });

        // Der Knopf neben der Liste wird leicht uebersehen — der Weg zum
        // Anlegen einer Mannschaft steht deshalb auch in der Liste selbst, und
        // dort oben: die Liste kann lang sein.
        options.unshift({
            label: '',
            options: {[CONFIG.ownSquadAddValue]: addSquadOption()}
        });

        return options;
    }

    function addSquadOption() {
        var label;

        label = __i18n('button/add');

        return {
            text: label,
            $html: $('<span>').addClass('select-option').append(
                $('<span>').addClass('select-option-info').append(
                    $('<span>').addClass('select-option-title').append(
                        $('<span>').addClass('color-green mr-small').html('<i class="fa-solid fa-plus"></i>'),
                        $('<span>').text(label)
                    )
                )
            )
        };
    }

    function squadOption(text, leagueLabel, logo) {
        var $html, $info;

        $html = $('<span>').addClass('select-option');

        if (logo) {
            $html.append($('<span>').addClass('select-option-logo').css('background-image', `url('${logo}')`));
        }

        $info = $('<span>').addClass('select-option-info').append(
            $('<span>').addClass('select-option-title').text(text)
        );

        if (leagueLabel) {
            $info.append($('<span>').addClass('select-option-note').text(leagueLabel));
        }

        return {
            text: text,
            $html: $html.append($info)
        };
    }

    function squadGroupLabel(source) {
        return [
            source.federationName || source.federationShortName || '',
            source.divisionName || ''
        ].filter(Boolean).join(' · ') || __i18n('squad/base/unassigned');
    }

    function squadGroupLine(image, text, isLogo) {
        return [
            '<span class="select-optgroup-line">',
                `<span class="select-optgroup-icon${isLogo ? ' is-logo' : ''}"${image ? ` style="background-image:url('${image}');"` : ''}></span>`,
                `<span class="select-optgroup-text">${__escapeHTML(text)}</span>`,
            '</span>'
        ].join('');
    }

    function buildSquadGroupHtml(source) {
        var lines;

        lines = [
            squadGroupLine(
                source.federationLogo || '',
                source.federationName || source.federationShortName || __i18n('squad/base/unassigned'),
                true
            )
        ];

        if (source.divisionName) {
            lines.push(squadGroupLine(
                source.divisionIcon ? `/res/img/game/${source.divisionIcon}.svg` : '',
                source.divisionName,
                false
            ));
        }

        return `<span class="select-optgroup">${lines.join('')}</span>`;
    }

    function matchdayGroupId() {
        return String(STATUS.data.groupId || '').trim();
    }

    function opponentOptionsSignature(groups) {
        var ids;

        ids = [];

        (groups || []).forEach(group => {
            Object.keys(group.options || {}).forEach(squadId => {
                ids.push(squadId);
            });
        });

        return ids.sort().join(',');
    }

    function markOwnSquadOption() {
        var control, ownSquadId;

        control = STATUS.form.controls.opponentSquadId;
        ownSquadId = STATUS.form.controls.ownSquadId.get();

        control.$getOptions().prop('disabled', false);

        if (ownSquadId) {
            control.$view.find(`select option[value="${ownSquadId}"]`).prop('disabled', true);
        }
    }

    function updateOpponentAvailability() {
        var control, isDisabled;

        control = STATUS.form.controls.opponentSquadId;
        isDisabled = !STATUS.form.controls.ownSquadId.get();

        control.$view.toggleClass('isDisabled', isDisabled);
        control.disable(isDisabled);
    }

    function loadOpponentSquads(includeSquadId) {
        return new Promise(function(resolve) {
            var previous;

            previous = STATUS.form.controls.opponentSquadId.get();

            Api.request('/battle/league/matchday/squads', {
                seasonId: STATUS.data.seasonId || '',
                groupId: matchdayGroupId(),
                includeSquadId: includeSquadId || ''
            }).then(result => {
                var groups, signature;

                groups = result.groups || [];
                signature = opponentOptionsSignature(groups);

                STATUS.opponentGroupId = matchdayGroupId();

                STATUS.form.controls.opponentSquadId.setOptions(
                    buildOpponentSquadOptions(groups),
                    {'': `-- ${__i18n('form/options/opponentSquad/none')} --`}
                );

                STATUS.form.controls.opponentSquadId.set(
                    (signature === STATUS.opponentOptionsSignature) ? previous : ''
                );

                STATUS.opponentOptionsSignature = signature;

                markOwnSquadOption();
                updateOpponentAvailability();
                updateOpponentCustomVisibility(true);
            }).catch(ignore => {
            }).finally(resolve);
        });
    }

    function buildOpponentSquadOptions(groups) {
        var options;

        options = groups.map(group => {
            var squadOptions;

            squadOptions = {};
            Object.keys(group.options || {}).forEach(squadId => {
                var option;
                option = group.options[squadId];
                squadOptions[squadId] = squadOption(option.text, option.leagueLabel, option.clubLogo);
            });

            return {
                label: squadGroupLabel(group),
                html: buildSquadGroupHtml(group),
                options: squadOptions
            };
        });

        options.push({
            label: '',
            options: {[CONFIG.opponentCustomValue]: __i18n('form/options/opponentSquad/custom')}
        });

        return options;
    }

    function onOpponentSquadChange() {
        var value;

        value = STATUS.form.controls.opponentSquadId.get();

        // The same team cannot be both sides of the matchup: reject and clear.
        // The manual-entry sentinel is never a duplicate.
        if (value && (value !== CONFIG.opponentCustomValue) && (value === STATUS.form.controls.ownSquadId.get())) {
            STATUS.form.controls.opponentSquadId.set('');
            updateOpponentCustomVisibility();
            showSquadDuplicateError();
            return;
        }

        updateOpponentCustomVisibility();
    }

    // Deferred past the picker close (see onOwnSquadChange) so the error dialog
    // does not fight the squad picker on the dialog stack.
    function showSquadDuplicateError() {
        chmDialog.afterTopClose(function() {
            chmDialog.error('matchday/squad/duplicate');
        });
    }

    // Shows the free-text opponent field only when the manual entry is chosen.
    function updateOpponentCustomVisibility(immediate) {
        var isCustom, $wrapper;

        if (!STATUS.$view) {
            return;
        }

        isCustom = (STATUS.form.controls.opponentSquadId.get() === CONFIG.opponentCustomValue);
        $wrapper = STATUS.$view.find('[data-id="opponentCustomWrapper"]');

        if (immediate) {
            $wrapper.css('display', isCustom ? '' : 'none');
        } else {
            $wrapper.stop()[isCustom ? 'slideDown' : 'slideUp'](200);
        }
    }

    // On an explicit home-team pick, carry the squad's league assignment over to
    // the matchday: adopt silently when the matchday has none, ask first when it
    // differs, do nothing when they already match.
    function onOwnSquadChange() {
        var squadId, squad, squadGroupId, currentGroupId;

        squadId = STATUS.form.controls.ownSquadId.get();

        // Keine Auswahl, sondern ein Weg: die Liste faellt auf ihren
        // Ausgangszustand zurueck, und der Mannschafts-Editor uebernimmt.
        if (squadId === CONFIG.ownSquadAddValue) {
            STATUS.form.controls.ownSquadId.set('');
            markOwnSquadOption();

            chmDialog.afterTopClose(function() {
                ScoreTrekBattle.View.openInline('/settings/squads');
            });

            return;
        }

        // The same team cannot be both sides of the matchup: reject and clear.
        if (squadId && squadId === STATUS.form.controls.opponentSquadId.get()) {
            STATUS.form.controls.ownSquadId.set('');
            showSquadDuplicateError();
            return;
        }

        markOwnSquadOption();

        squad = (STATUS.ownSquads && STATUS.ownSquads[squadId]) ? STATUS.ownSquads[squadId] : null;

        if (!squad) {
            return;
        }

        squadGroupId = String(squad.groupId || '').trim();

        if (!squadGroupId) {
            return;
        }

        currentGroupId = String(STATUS.data.groupId || '').trim();

        if (!currentGroupId) {
            adoptGroupFromSquad(squad);
            return;
        }

        if (currentGroupId === squadGroupId) {
            return;
        }

        // Deferred until the squad picker (chmSelect) has fully closed: the change
        // event fires inside the picker's confirm action, so opening the prompt any
        // earlier either sticks the picker open on the dialog stack or overlaps its
        // close animation. The team stays selected; the prompt follows afterwards.
        chmDialog.afterTopClose(function() {
            chmDialog.confirm(__i18n('matchday/league/adopt/text', {squad: squad.label, group: squad.groupLabel || ''}, true), {
                title: __i18n('matchday/league/adopt/title'),
                buttonYes: __i18n('button/apply'),
                buttonNo: __i18n('button/cancel')
            }).then(() => {
                adoptGroupFromSquad(squad);
            }).catch(ignore => {});
        });
    }

    function adoptGroupFromSquad(squad) {
        CONFIG.leagueFilterOrder.forEach(filterKey => {
            STATUS.data[filterKey] = String(squad[filterKey] || '').trim();
        });

        STATUS.data.groupLabel = squad.groupLabel || '';

        // The group belongs to the squad's season — carry it over to the matchday.
        if (squad.seasonId) {
            STATUS.data.seasonId = String(squad.seasonId).trim();
            STATUS.form.controls.seasonId.set(STATUS.data.seasonId);
        }

        updateGroupDisplay();
    }

    function attachPickerCascade(controls) {
        CONFIG.leagueFilterOrder.forEach(filterKey => {
            controls[filterKey].on('change', function() {
                if (STATUS.pickerRestoring) {
                    return;
                }
                loadPickerFilters(controls, filterKey);
            });
        });
    }

    function getPickerValues(controls) {
        var filters;
        filters = {};
        CONFIG.leagueFilterOrder.forEach(filterKey => {
            var value;
            value = String(controls[filterKey].get() || '').trim();
            if (value) {
                filters[filterKey] = value;
            }
        });
        return filters;
    }

    function loadPickerFilters(controls, changedKey, restoreValues) {
        var requestId, filters;

        STATUS.pickerRequestId = (STATUS.pickerRequestId || 0) + 1;
        requestId = STATUS.pickerRequestId;

        filters = restoreValues || getPickerValues(controls);

        // Scope the cascade to the matchday's fixed season (removed from the
        // picker UI); the backend reads seasonId from the filters like any other.
        if (STATUS.pickerSeasonId) {
            filters = $.extend({}, filters, {seasonId: STATUS.pickerSeasonId});
        }

        Api.request('/battle/league/matchday/filters', {
            filters: filters,
            changed: changedKey
        }).then(result => {
            var allFilters, disabled;

            if (requestId !== STATUS.pickerRequestId) {
                return;
            }
            if (!result || !result.filters) {
                return;
            }

            allFilters = result.filters;
            disabled = result.disabled || [];

            STATUS.pickerRestoring = true;

            disabled.forEach(filterKey => {
                if (CONFIG.leagueFilterOrder.indexOf(filterKey) >= 0) {
                    resetPickerFilter(controls, filterKey);
                    disablePickerFilter(controls, filterKey);
                }
            });

            CONFIG.leagueFilterOrder.forEach(filterKey => {
                var options;
                if (!allFilters.hasOwnProperty(filterKey)) {
                    return;
                }
                options = ScoreTrekBattle.League.Select.formatOptions(allFilters[filterKey].values || {});
                controls[filterKey].setOptions(options, {'': `-- ${__i18n('filter/all')} --`});
                enablePickerFilter(controls, filterKey);
                if (restoreValues && restoreValues[filterKey]) {
                    controls[filterKey].set(restoreValues[filterKey]);
                }
            });

            // Preselect the club's federation (country + federation) on a fresh
            // dialog when nothing has been chosen yet.
            if (result.preselect) {
                ['countryId', 'federationId'].forEach(filterKey => {
                    if (controls[filterKey] && result.preselect[filterKey]) {
                        controls[filterKey].set(result.preselect[filterKey]);
                    }
                });
            }

            STATUS.pickerRestoring = false;
        }).catch(ignore => {
            STATUS.pickerRestoring = false;
        });
    }

    function enablePickerFilter(controls, filterKey) {
        var control;
        control = controls[filterKey];
        if (!control) {
            return;
        }
        control.$view.removeClass('isDisabled');
        control.$view.find('select').prop('disabled', false);
    }

    function disablePickerFilter(controls, filterKey) {
        var control;
        control = controls[filterKey];
        if (!control) {
            return;
        }
        control.$view.addClass('isDisabled');
        control.$view.find('select').prop('disabled', true);
    }

    function resetPickerFilter(controls, filterKey) {
        var control;
        control = controls[filterKey];
        if (!control) {
            return;
        }
        control.setOptions({}, {'': `-- ${__i18n('filter/all')} --`});
        control.set(null);
    }

    function saveMatchday() {
        var data;

        data = $.extend(STATUS.data, STATUS.form.get());

        // groupId is maintained via the group picker dialog, not a form control.
        data.groupId = STATUS.data.groupId || '';
        // seasonId is a form control, but STATUS.data stays authoritative (it also
        // tracks group adoption from the home squad).
        data.seasonId = STATUS.data.seasonId || '';

        validateData(data, STATUS.form.getHidden(), CONFIG.validationLeague).then(validData => {
            // Resolve the opponent AFTER validation, because validateData nulls
            // hidden fields (opponentSquadName is hidden when a listed squad is used).
            normalizeMatchdayOpponent(validData);

            validData.groupId = STATUS.data.groupId || '';
            validData.seasonId = STATUS.data.seasonId || '';

            // The league visibility widget maps onto the model's isPublic field
            // (isPublic is named identically in both models); the widget id stays
            // distinct only to avoid a control-name clash with the tournament
            // isPublic control in the shared form.
            validData.isPublic = !!validData.isPublicMatchday;
            delete validData.isPublicMatchday;

            if (!validData.groupId) {
                STATUS.form.errors([{
                    field: 'groupId',
                    message: __i18n('error/field/mandatory')
                }]);
                chmDialog.error('matchday/league/required');
                return;
            }

            // Opponent is valid with either a picked squad or a free-text name.
            if (!validData.opponentSquadId && !String(validData.opponentSquadName || '').trim()) {
                STATUS.form.errors([{
                    field: 'opponentSquadId',
                    message: __i18n('error/field/mandatory')
                }]);
                return;
            }
            STATUS.form.errors([]);
            publishMatchday({
                matchday: prepareData(validData, ['dateTimeMatchday'])
            });
        }).catch(errors => {
            STATUS.form.errors(errors);
        });
    }

    // Maps the opponent picker onto the stored fields: a picked squad populates
    // opponentSquadId (name resolved server-side), the manual entry populates the
    // free-text opponentSquadName instead.
    function normalizeMatchdayOpponent(data) {
        if (data.opponentSquadId === CONFIG.opponentCustomValue) {
            data.opponentSquadId = '';
            data.opponentSquadName = String(data.opponentSquadName || '').trim();
        } else {
            data.opponentSquadId = String(data.opponentSquadId || '').trim();
            data.opponentSquadName = '';
        }
    }

    function publishMatchday(data) {
        ScoreTrekBattle.View.loading('Tournament.Edit.publishMatchday', true);
        Api.request(STATUS.isNew ? '/battle/league/matchday/create' : '/battle/league/matchday/update', data).then(result => {
            if (result && result.done) {
                if (result.matchday) {
                    ScoreTrekBattle.Event.trigger(STATUS.isNew ? 'matchday.created' : 'matchday.updated', STATUS.isNew ? [result.matchday, ''] : [result.matchday.id]);
                }

                chmDialog.success(__i18n(STATUS.isNew ? 'matchday/create/done' : 'matchday/update/done'), null, __i18n('button/ok')).then(() => {
                    if (STATUS.data.seasonId) {
                        localStorage.setItem(CONFIG.matchdaySeasonStorageKey, STATUS.data.seasonId);
                    }
                    ScoreTrekBattle.View.goto('/league/plan');
                });
            } else {
                chmDialog.error(`matchday/${STATUS.isNew ? 'create' : 'update'}/failed`);
            }
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Edit.publishMatchday', false);
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function onCheckAccess() {
        return ScoreTrekBattle.Session.isBattleManager();
    }

    function updateTitle() {
        var prefix;

        if (!STATUS.$view) {
            return;
        }

        prefix = isLeagueMode() ? 'matchday' : 'tournament';

        STATUS.$view.find('[data-id="introTitle"]').html(__i18n(`${prefix}/form/${STATUS.isNew ? 'create' : 'edit'}/title`));
        STATUS.$view.find('[data-id="introText"]').html(__i18n(`${prefix}/form/${STATUS.isNew ? 'create' : 'edit'}/text`));
    }

    function applyMode() {
        var isLeague;

        if (!STATUS.$view) {
            return;
        }

        isLeague = isLeagueMode();

        STATUS.$view.attr('data-editor-mode', STATUS.mode);
        STATUS.$view.find('[data-mode="league"]').css('display', isLeague ? '' : 'none');
        STATUS.$view.find('[data-mode="tournament"]').css('display', isLeague ? 'none' : '');
    }

    function addEventListeners() {
        STATUS.$view.find('[data-ref-id]').each(function() {
            var refId, control, $element;
            refId = this.dataset.refId;
            if (STATUS.view.controls.hasOwnProperty(refId)) {
                control = STATUS.view.controls[refId];
                $element = $(this)[control.get() ? 'show' : 'hide']();
                control.on('change', function() {
                    $element.stop()[this.get() ? 'slideDown' : 'slideUp'](400);
                });
            }
        });

        if (STATUS.view.controls.hasOwnProperty('seasonId')) {
            STATUS.view.controls['seasonId'].on('change', function() {
                onMatchdaySeasonChange();
            });
        }

        if (STATUS.view.controls.hasOwnProperty('ownSquadId')) {
            STATUS.view.controls['ownSquadId'].on('change', function() {
                onOwnSquadChange();
            });
        }

        if (STATUS.view.controls.hasOwnProperty('opponentSquadId')) {
            STATUS.view.controls['opponentSquadId'].on('change', function() {
                onOpponentSquadChange();
            });
        }

        STATUS.view.controls['presetId'].on('change', function() {
            let $editButton, $addButton;

            STATUS.data.preset = STATUS.presets[this.get()];

            $editButton = STATUS.$view.find('[data-id="editPreset"]');
            $addButton = STATUS.$view.find('[data-id="createPreset"]');

            $editButton.attr('href', `${$editButton.attr('data-href')}${this.get()}/return:tournament.edit/${STATUS.data.id}`);
            $addButton.attr('href', `${$addButton.attr('data-href')}return:tournament.edit/${STATUS.data.id}`);
        });

        STATUS.view.controls['pointsMapId'].on('change', function() {
            let $editButton, $addButton, pointsMapId, isEditable;

            pointsMapId = this.get();
            isEditable = (pointsMapId !== '');
            STATUS.data.pointsMap = STATUS.pointsMaps[pointsMapId] || null;

            ['edit', 'clone', 'rename', 'delete'].forEach(pointsMapAction => {
                STATUS.$view.find(`[data-points-map-action="${pointsMapAction}"]`).toggleClass('isDisabled', !isEditable);
            });

            $editButton = STATUS.$view.find('[data-id="editPointsMap"]');
            $addButton = STATUS.$view.find('[data-id="createPointsMap"]');

            $editButton.attr('href', `${$editButton.attr('data-href')}${pointsMapId}/return:tournament.edit/${STATUS.data.id}`);
            $addButton.attr('href', `${$addButton.attr('data-href')}return:tournament.edit/${STATUS.data.id}`);
        });

        STATUS.view.controls['hasWaitlist'].on('change', function() {
            if (parseInt(STATUS.view.controls['waitlistLimit'].get(), 10) === 0) {
                STATUS.view.controls['waitlistLimit'].set(10);
            }
        });

        STATUS.view.controls['hasRegistration'].on('change', function() {
            if (!this.get()) {
                return;
            }
            STATUS.view.controls['isInvitation'].set(false);
        });

        STATUS.view.controls['isInvitation'].on('change', function() {
            if (!this.get()) {
                return;
            }
            STATUS.view.controls['hasRegistration'].set(false).trigger('change');
        });
    }

    function getInitialData(preset) {
        let initialData;

        player = ScoreTrekBattle.Session.getPlayer();
        club = getClub();

        initialData = {
            id: '',
            clubId: '',
            modified: null,
            status: 'preparing',
            presetId: preset ? preset.id : '',
            title: preset ? preset.name : '',
            entryFee: '',
            approvalNumber: '',
            dressCode: '',
            locationStreet: club ? (club.address ? `${club.address.street} ${club.address.number}`.trim() : club.street) : '',
            locationZip: club ? (club.address ? club.address.zip : club.zip) : '',
            locationCity: club ? (club.address ? club.address.city : club.city) : '',
            isPublic: true,    
            hasRegistration: false,
            hasWithdrawLimit: false,
            hasWaitlist: false,
            timeZone: DateTime.getCurrentTimeZone(),
            waitlistLimit: 10
        };

        CONFIG.dateTimeAutofill.forEach(field => {
            initialData[`${field}Date`] = DateTime.getCurrentDateString();
            initialData[`${field}Time`] = DateTime.getCurrentTimeString(false, true);
        });

        return initialData;
    }

    function getClub() {
        return STATUS.club ? STATUS.club : ((STATUS.data && STATUS.data.club) ? STATUS.data.club : ScoreTrekBattle.Session.getPlayerClub());
    }

    function prepareForm() {
        return new Promise(function(resolvePrepareForm) {
            STATUS.form.controls.timeZone.setOptions(DataHandler.arrayToObject(DateTime.getTimeZones()));

            if (isLeagueMode()) {
                // League selects (cascade + opponent clubs) are populated in
                // initLeagueControls once the matchday data has been loaded.
                resolvePrepareForm();
                return;
            }

            Promise.all([
                updatePresets(),
                updatePointsMaps(),
                updateSeries(),
                updateNextTournament(),
                updateClub()
            ]).then(resolvePrepareForm);
        });
    }

    function convertPresetListToOptions(list) {
        return DataHandler.arrayToOptions(list, 'id', function() {
            return `${this.name} (${this.preset.playerLimit * this.teamSize} ${__i18n('player/players')})`;
        });
    }

    function convertPointsMapListToOptions(list) {
        return DataHandler.arrayToOptions(list, 'id', function() {
            return `${this.name}`;
        });
    }

    function updateClub() {
        return new Promise(function(resolve) {
            if (!STATUS.active) {
                resolve();
                return;
            }
            Api.request('/battle/club/all').then(result => {
                STATUS.clubs = DataHandler.arrayToAssoc(result.list, 'id');

                // STATUS.form.controls.clubId.setOptions(
                //     DataHandler.arrayToOptions(Object.values(STATUS.STATUS.clubs), 'id', function() {
                //         return `${this.name}`;
                //     }),
                //     {'': `-- ${__i18n('form/options/clubId/none')} --`}
                // );
            }).catch(ignore => {
            }).finally(() => {
                resolve();
            });
        });
    }

    function updatePresets(showLoading) {
        return new Promise(function(resolve) {
            if (!STATUS.active) {
                resolve();
                return;
            }
            if (showLoading) {
                ScoreTrekBattle.View.loading('Tournament.Edit.updatePresets', true);
            } else {
                ScoreTrekBattle.View.loadingBackground('Tournament.Edit.updatePresets', true);
            }
            Api.request('/battle/tournament/preset/list', {extended: true}).then(result => {
                STATUS.presets = DataHandler.arrayToAssoc(result.list.concat(result.officialList), 'id');
                STATUS.form.controls.presetId.setOptions(convertPresetListToOptions(result.list));
            }).catch(ignore => {
            }).finally(() => {
                if (showLoading) {
                    ScoreTrekBattle.View.loading('Tournament.Edit.updatePresets', false);
                } else {
                    ScoreTrekBattle.View.loadingBackground('Tournament.Edit.updatePresets', false);
                }
                resolve();
            });
        });
    }

    function updatePointsMaps(showLoading) {
        return new Promise(function(resolve) {
            if (!STATUS.active) {
                resolve();
                return;
            }
            if (showLoading) {
                ScoreTrekBattle.View.loading('Tournament.Edit.updatePointsMaps', true);
            } else {
                ScoreTrekBattle.View.loadingBackground('Tournament.Edit.updatePointsMaps', true);
            }
            Api.request('/battle/tournament/pointsMap/list', {extended: true}).then(result => {
                STATUS.pointsMaps = DataHandler.arrayToAssoc(result.list, 'id');
                STATUS.form.controls.pointsMapId.setOptions(convertPointsMapListToOptions([{id: '', name: __i18n('form/options/pointsMap/default')}].concat(result.list)));
            }).catch(ignore => {
            }).finally(() => {
                if (showLoading) {
                    ScoreTrekBattle.View.loading('Tournament.Edit.updatePointsMaps', false);
                } else {
                    ScoreTrekBattle.View.loadingBackground('Tournament.Edit.updatePointsMaps', false);
                }
                resolve();
            });
        });
    }

    function updateSeries() {
        return new Promise(function(resolve) {
            if (!STATUS.active) {
                resolve();
                return;
            }
            Api.request('/battle/tournament/series/all').then(result => {
                STATUS.series = DataHandler.arrayToAssoc(result.list, 'id');
                STATUS.form.controls.seriesId.setOptions(
                    DataHandler.arrayToOptions(result.list, 'id', 'title'),
                    {'': `-- ${__i18n('tournament/series/none')} --`}
                );
            }).catch(ignore => {
            }).finally(() => {
                resolve();
            });
        });
    }

    function updateNextTournament() {
        return new Promise(function(resolve) {
            if (!STATUS.active) {
                resolve();
                return;
            }
            Api.request('/battle/tournament/all', {addRelatedClubs: true}).then(result => {
                let optgroups;

                STATUS.tournaments = DataHandler.arrayToAssoc(result.list, 'id');
                delete STATUS.tournaments[STATUS.tournamentId];

                optgroups = DataHandler.arrayToOptGroups(Object.values(STATUS.tournaments), 'id', function() {
                    return {
                        text: this.title,
                        $html: ScoreTrekBattle.Tournament.renderSelectItem(this)
                    };
                }, null, 'clubId', 'clubName');

                optgroups.sort((optgroupA, optgroupB) => {
                    return (optgroupA.label < optgroupB.label) ? -1 : 1;
                });

                STATUS.form.controls.nextTournamentId.setOptions(
                    optgroups,
                    {'': `-- ${__i18n('form/options/nextTournamentId/none')} --`}
                );
            }).catch(ignore => {
            }).finally(() => {
                resolve();
            });
        });
    }

    function renderData() {
        let club, hasPresetId, hasSeriesId;

        if (!STATUS.form) {
            console.error('Missing form.');
            return;
        }

        club = getClub();

        CONFIG.dateTimeAutofill.forEach(field => {
            if (STATUS.data[`${field}Timestamp`] === 0) {
                STATUS.data[`${field}Date`] = DateTime.getCurrentDateString(false, true);
                STATUS.data[`${field}Time`] = DateTime.getCurrentTimeString(false, true);
            }
        });

        if (club) {
            STATUS.$view.find('[data-id="clubLogo"]').css('background-image', `url('${club.logo}')`);
            STATUS.$view.find('[data-id="clubName"]').text(club.name);
        } else {
            STATUS.$view.find('[data-id="club"]').hide();
        }

        STATUS.form.fields.forEach(field => {
            if (STATUS.data.hasOwnProperty(field.name)) {
                field.set(STATUS.data[field.name]);
            }
        });

        STATUS.$view.attr('data-tournament-status', STATUS.data.statusInfo || 'preparing');

        STATUS.$view.find('input, select, textarea').trigger('change');

        if (STATUS.isLimitedEdit) {
            STATUS.form.disable();
        }

        if (STATUS.limitedEditableFields && (STATUS.limitedEditableFields.length > 0)) {
            STATUS.limitedEditableFields.forEach(fieldName => {
                if (STATUS.form.controls.hasOwnProperty(fieldName)) {
                    STATUS.form.controls[fieldName].disable(false);
                }
            });

            hasPresetId = STATUS.limitedEditableFields.indexOf('presetId') >= 0;
            hasSeriesId = STATUS.limitedEditableFields.indexOf('seriesId') >= 0;
            hasPointsMapId = STATUS.limitedEditableFields.indexOf('pointsMapId') >= 0;

            STATUS.$view.find('[data-id="presetEditButton"]').toggleClass('isDisabled', !hasPresetId).prop('disabled', !hasPresetId);
            STATUS.$view.find('[data-id="seriesEditButton"]').toggleClass('isDisabled', !hasSeriesId).prop('disabled', !hasSeriesId);
            STATUS.$view.find('[data-id="pointsMapEditButton"]').toggleClass('isDisabled', !hasPointsMapId).prop('disabled', !hasPointsMapId);
        }
    }

    function validateData(data, ignoreFields, rules) {
        return new Promise(function(resolve, reject) {
            var errors;
            errors = [];

            rules = rules || CONFIG.validation;

            Object.keys(rules).forEach(fieldName => {
                var validate, isMandatory;

                if (ignoreFields.indexOf(fieldName) >= 0) {
                    return;
                }

                validate = rules[fieldName];

                isMandatory = validate.mandatory;

                if (!isMandatory && validate.mandatoryIfChecked) {
                    isMandatory = true;
                    validate.mandatoryIfChecked.forEach(refFieldName => {
                        isMandatory = isMandatory && data[refFieldName];
                    });
                }

                if (isMandatory && !data[fieldName]) {
                    errors.push({
                        field: fieldName,
                        message: __i18n('error/field/mandatory')
                    });
                }

                if (validate.range && ((data[fieldName] < validate.range.min) || (data[fieldName] > validate.range.max))) {
                    errors.push({
                        field: fieldName,
                        message: __i18n('error/field/range', validate.range)
                    });
                }
            });

            Object.keys(CONFIG.dateTimeValidation).forEach(fieldName => {
                if (data[fieldName]) {
                    errors = validateDateField(CONFIG.dateTimeValidation[fieldName], data, errors);
                }
            });

            ignoreFields.forEach(fieldName => {
                if (data.hasOwnProperty(fieldName)) {
                    data[fieldName] = null;
                }
            });

            if (errors.length === 0) {
                resolve(data);
            } else {
                reject(errors);
            }
        });
    }

    function validateDateField(fieldName, data, errors) {
        if (isDateEqual(data[`${fieldName}Date`], data.dateTimeTournamentDate, false)) {
            if (!isTimeSmaller(data[`${fieldName}Time`], data.dateTimeTournamentTime)) {
                errors.push({
                    field: `${fieldName}Time`,
                    message: __i18n(`error/field/${fieldName}`)
                });
            }
        } else {
            if (!isDateSmaller(data[`${fieldName}Date`], data.dateTimeTournamentDate, true)) {
                errors.push({
                    field: `${fieldName}Date`,
                    message: __i18n(`error/field/${fieldName}`)
                });
            }
        }

        return errors;
    }

    function isDateEqual(dateObjA, dateObjB, defaultReturn) {
        if (!dateObjA || !dateObjB) {
            return !!defaultReturn;
        }
        return ((dateObjA.year === dateObjB.year) && (dateObjA.month === dateObjB.month) && (dateObjA.day === dateObjB.day));
    }

    function isDateSmaller(dateObjA, dateObjB, defaultReturn) {
        if (!dateObjA || !dateObjB) {
            return !!defaultReturn;
        }
        return ((dateObjA.year < dateObjB.year) || ((dateObjA.year === dateObjB.year) && (dateObjA.month < dateObjB.month)) || ((dateObjA.year === dateObjB.year) && (dateObjA.month === dateObjB.month) && (dateObjA.day < dateObjB.day)));
    }

    function isTimeSmaller(timeObjA, timeObjB, defaultReturn) {
        if (!timeObjA || !timeObjB) {
            return !!defaultReturn;
        }
        return ((timeObjA.hour < timeObjB.hour) || ((timeObjA.hour === timeObjB.hour) && (timeObjA.minute < timeObjB.minute)));
    }

    function confirmPreview(data) {
        return new Promise(function(resolve, reject) {
            data.description = String(data.description).trim().replace(/(\r?\n){3,}/g, "\n\n");
            ScoreTrekBattle.Template.render('tournament/edit/preview', {
                tournament: data
            }, true).then(preview => {
                if (!data.intro) {
                    preview.$view.find('[data-id="intro"]').hide();
                }
                if (!data.hasWaitlist) {
                    preview.$view.find('[data-id="waitlist"]').hide();
                }
                if (!data.hasRegistration) {
                    preview.$view.find('[data-id="registration"]').hide();
                }
                if (!data.isInvitation) {
                    preview.$view.find('[data-id="invitation"]').hide();
                }
                if (!data.hasWithdrawLimit) {
                    preview.$view.find('[data-id="withdrawLimit"]').hide();
                }
                preview.$view.find(`[data-id="pointsMapId"]`).text(STATUS.pointsMaps[data.pointsMapId] ? STATUS.pointsMaps[data.pointsMapId].name : __i18n('form/options/pointsMap/default'));
                preview.$view.find(`[data-id="seriesId"]`).text(STATUS.series[data.seriesId] ? STATUS.series[data.seriesId].title : '');
                preview.$view.find(`[data-id="nextTournamentId"]`).html(STATUS.tournaments[data.nextTournamentId] ? `${__escapeHTML(STATUS.tournaments[data.nextTournamentId].title)} <span class="color-white-50">${STATUS.tournaments[data.nextTournamentId].dateTimeTournament}</span>` : '');
                CONFIG.previewOptional.forEach(field => {
                    if (!data[field] || !String(data[field]).trim()) {
                        preview.$view.find(`[data-id="${field}"]`).html(`<span class="text-italic color-white-50">${__i18n('form/none')}</span>`);
                    }
                });
                chmDialog({
                    content: preview.$view,
                    buttons: [
                        {
                            label: __i18n(STATUS.isNew ? 'button/confirm' : 'button/apply'),
                            icon: '<i class="fa-solid fa-check"></i>',
                            primary: true,
                            action: () => {
                                resolve();
                            }
                        },
                        {
                            label: __i18n('button/cancel'),
                            secondary: true
                        }
                    ]
                });
            });
        });
    }

    function publishTournament(data) {
        ScoreTrekBattle.View.loading('Tournament.Edit.publishTournament', true);
        Api.request(STATUS.isNew ? '/battle/tournament/create' : '/battle/tournament/update', data).then(result => {
            if (result && result.done) {
                chmDialog.success(__i18n(STATUS.isNew ? 'tournament/create/done' : 'tournament/update/done'), null, __i18n('button/ok')).then(() => {
                    if (result.tournament) {
                        ScoreTrekBattle.View.goto(`/tournament/plan/${result.tournament.id}`);
                        ScoreTrekBattle.Tournament.List.focus(result.tournament.id);
                    }
                });
            } else {
                chmDialog.error(`tournament/${STATUS.isNew ? 'create' : 'update'}/failed`);
            }
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Edit.publishTournament', false);
        });
    }

    function prepareData(data, dateTimeFields) {
        var requestData;
        requestData = DataHandler.cloneObject(data);
        (dateTimeFields || CONFIG.dateTimeFields).forEach(fieldName => {
            requestData[fieldName] = `${DataHandler.formatDateObject(requestData[`${fieldName}Date`])} ${DataHandler.formatTimeObject(requestData[`${fieldName}Time`])}`;
            delete requestData[`${fieldName}Date`];
            delete requestData[`${fieldName}Time`];
        });
        return requestData;
    }

    function deleteTournament(tournamentId) {
        return tournamentAction('delete', tournamentId);
    }

    function resetTournament(tournamentId) {
        return tournamentAction('reset', tournamentId);
    }

    function cloneTournament(tournamentId) {
        return tournamentAction('clone', tournamentId);
    }

    function toggleTournamentIsPublic($tournament, isPublic) {
        var tournamentId, tournamentTitle, isListElement;

        tournamentId = $tournament.attr('data-tournament-id');
        tournamentTitle = $tournament.find('[data-id="tournamentTitle"]').text();
        isListElement = $tournament.hasClass('tournament-list-item');

        chmDialog.confirm(
            __i18n(
                isPublic ? 'dialog/confirm/makePublic/text' : 'dialog/confirm/makePrivate/text',
                {
                    colorClass: 'color-blue',
                    reference: tournamentTitle
                },
                true
            ),
            {
                title: __i18n(isPublic ? 'dialog/confirm/makePublic/title' : 'dialog/confirm/makePrivate/title'),
                buttonYes: __i18n('button/toggle'),
                buttonNo: __i18n('button/cancel')
            }
        ).then(() => {
            let promise;

            promise = isPublic ? tournamentAction('makePublic', tournamentId) : tournamentAction('makePrivate', tournamentId);
            promise.then(newTournament => {
                if (isListElement) {
                    return;
                }

                $tournament.attr('data-event-is-public', isPublic ? 'yes' : 'no');
            }).catch(ignore => {});
        }).catch(ignore => {});

    }

    function confirmCancelTournament(tournamentId, tournamentTitle) {
        return new Promise(function(resolve, reject) {
            chmDialog.confirm(__i18n('dialog/confirm/cancelTournament/text', {tournamentName: tournamentTitle}, true), {
                title: __i18n('dialog/confirm/cancelTournament/title'),
                buttonYes: __i18n('button/yes'),
                buttonNo: __i18n('button/no')
            }).then(() => {
                chmDialog.confirm(__i18n('dialog/confirm/cancelTournamentReassure/text', {tournamentName: tournamentTitle}, true), {
                    title: __i18n('dialog/confirm/cancelTournamentReassure/title'),
                    buttonYes: __i18n('button/no'),
                    buttonNo: __i18n('button/yes')
                }).then(reject).catch(() => {
                    cancelTournament(tournamentId).then(resolve).catch(reject);
                });
            }).catch(reject);
        });
    }

    function confirmAnnulTournament(tournamentId, tournamentTitle) {
        return new Promise(function(resolve, reject) {
            chmDialog.confirm(__i18n('dialog/confirm/annulTournament/text', {tournamentName: tournamentTitle}, true), {
                title: __i18n('dialog/confirm/annulTournament/title'),
                buttonYes: __i18n('button/yes'),
                buttonNo: __i18n('button/no')
            }).then(() => {
                chmDialog.confirm(__i18n('dialog/confirm/annulTournamentReassure/text', {tournamentName: tournamentTitle}, true), {
                    title: __i18n('dialog/confirm/annulTournamentReassure/title'),
                    buttonYes: __i18n('button/no'),
                    buttonNo: __i18n('button/yes')
                }).then(reject).catch(() => {
                    annulTournament(tournamentId).then(resolve).catch(reject);
                });
            }).catch(reject);
        });
    }

    function cancelTournament(tournamentId) {
        return new Promise(function(resolve, reject) {
            setTournamentStatus(tournamentId, 'cancelled').then(resolve).catch(error => {
                if (error) {
                    chmDialog.error(error);
                }
                reject();
            });
        });
    }

    function annulTournament(tournamentId) {
        return new Promise(function(resolve, reject) {
            setTournamentStatus(tournamentId, 'annulled').then(resolve).catch(error => {
                if (error) {
                    chmDialog.error(error);
                }
                reject();
            });
        });
    }

    function setTournamentStatus(tournamentId, status) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Edit.setStatus', true);
            Api.request(`/battle/tournament/status`, {
                status: status,
                tournamentId: tournamentId
            }).then(result => {
                if (result.tournament) {
                    ScoreTrekBattle.Event.trigger('tournament.updated', result.tournament);
                }

                if (result.done && result.tournament) {
                    resolve(result.tournament);
                } else {
                    reject(__i18n('error/STATUS_TRANSITION_FAILED'));
                }
            }).catch(error => {
                reject((error && error.message) ? __i18n(`error/${error.message}`) : __i18n('error/STATUS_TRANSITION_FAILED'));
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.setStatus', false);
            });
        });
    }

    // action: delete | reset | clone | makePublic | makePrivate
    function tournamentAction(action, tournamentId) {
        return new Promise(function(resolve, reject) {
            let isDeleted, isCloned;

            isDeleted = (action === 'delete');
            isCloned = (action === 'clone');

            ScoreTrekBattle.View.loading('Tournament.Edit.tournamentAction', true);
            Api.request(`/battle/tournament/${action}`, {id: tournamentId}).then(result => {
                if (!isCloned && result.tournament) {
                    ScoreTrekBattle.Event.trigger(isDeleted ? 'tournament.deleted' : 'tournament.updated', result.tournament);
                }
                resolve(result.tournament);
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.tournamentAction', false);
            });
        });
    }

    _this = {
        setStatus: function(tournamentId, status) {
            return setTournamentStatus(tournamentId, status);
        }
    };

    ScoreTrekBattle.View.register('/tournament/create', onViewRenderCreate, onViewLoadCreate, onViewUpdate, onViewUnload, onCheckAccess);
    ScoreTrekBattle.View.register('/tournament/edit', onViewRenderEdit, onViewLoadEdit, onViewUpdate, onViewUnload, onCheckAccess);
    ScoreTrekBattle.View.register('/league/matchday/create', onViewRenderMatchdayCreate, onViewLoadMatchdayCreate, onViewUpdate, onViewUnload, onCheckAccess);
    ScoreTrekBattle.View.register('/league/matchday/edit', onViewRenderMatchdayEdit, onViewLoadMatchdayEdit, onViewUpdate, onViewUnload, onCheckAccess);

    ScoreTrekBattle.Event.on('action.groupId.select', function() {
        openGroupPicker();
    });

    ScoreTrekBattle.Event.on('action.schedule.preview', function() {
        var data;

        if (isLeagueMode()) {
            saveMatchday();
            return;
        }

        data = $.extend(STATUS.data, STATUS.form.get());
        validateData(data, STATUS.form.getHidden()).then(validData => {
            STATUS.form.errors([]);
            confirmPreview(validData).then(() => {
                publishTournament({
                    tournament: prepareData(validData)
                });
            });
        }).catch(errors => {
            STATUS.form.errors(errors);
        });
    });

    ScoreTrekBattle.Event.on('action.tournament.cancel', function() {
        let $tournament, tournamentId, tournamentTitle, isListElement;

        $tournament = $(this).closest('[data-tournament-id]');
        tournamentId = $tournament.attr('data-tournament-id');
        tournamentTitle = $tournament.find('[data-id="tournamentTitle"]').text();
        isListElement = $tournament.hasClass('tournament-list-item');

        confirmCancelTournament(tournamentId, tournamentTitle).then(updatedTournament => {
            if (isListElement) {
                return;
            }

            ScoreTrekBattle.View.goto(`/tournament/scheduled/focus:${updatedTournament.id}`);
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.tournament.annul', function() {
        let $tournament, tournamentId, tournamentTitle, isListElement;

        $tournament = $(this).closest('[data-tournament-id]');
        tournamentId = $tournament.attr('data-tournament-id');
        tournamentTitle = $tournament.find('[data-id="tournamentTitle"]').text();
        isListElement = $tournament.hasClass('tournament-list-item');

        confirmAnnulTournament(tournamentId, tournamentTitle).then(() => {
            if (isListElement) {
                return;
            }

            $tournament.attr('data-tournament-status', 'annulled');
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.tournament.delete', function() {
        var $tournament, tournamentId, tournamentTitle, isListElement;

        $tournament = $(this).closest('[data-tournament-id]');
        tournamentId = $tournament.attr('data-tournament-id');
        tournamentTitle = $tournament.find('[data-id="tournamentTitle"]').text();
        isListElement = $tournament.hasClass('tournament-list-item');

        chmDialog.confirm(__i18n('dialog/confirm/delete/text', {colorClass: 'color-blue', reference: tournamentTitle}, true), {
            title: __i18n('dialog/confirm/delete/title'),
            buttonYes: __i18n('button/delete'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            deleteTournament(tournamentId, isListElement).then(() => {
                ScoreTrekBattle.Event.trigger('tournament.deleted', tournamentId);

                if (isListElement) {
                    return;
                }

                ScoreTrekBattle.View.goto('/tournament/plan');
            }).catch(ignore => {});
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.tournament.reset', function() {
        var $tournament, tournamentId, tournamentTitle, isListElement;

        $tournament = $(this).closest('[data-tournament-id]');
        tournamentId = $tournament.attr('data-tournament-id');
        tournamentTitle = $tournament.find('[data-id="tournamentTitle"]').text();
        isListElement = $tournament.hasClass('tournament-list-item');
        
        chmDialog.confirm(__i18n('dialog/confirm/resetTournament/text', {tournamentName: tournamentTitle}, true), {
            title: __i18n('dialog/confirm/resetTournament/title'),
            buttonYes: __i18n('button/yes'),
            buttonNo: __i18n('button/no')
        }).then(() => {
            chmDialog.confirm(__i18n('dialog/confirm/resetTournamentReassure/text', {tournamentName: tournamentTitle}, true), {
                title: __i18n('dialog/confirm/resetTournamentReassure/title'),
                buttonYes: __i18n('button/no'),
                buttonNo: __i18n('button/yes')
            }).catch(() => {
                resetTournament(tournamentId, isListElement).then(updatedTournament => {
                    if (isListElement) {
                        return;
                    }

                    ScoreTrekBattle.View.goto(`/tournament/scheduled/focus:${updatedTournament.id}`);
                }).catch(ignore => {});
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.tournament.makePrivate', function() {
        toggleTournamentIsPublic($(this).closest('[data-tournament-id]'), false);
    });

    ScoreTrekBattle.Event.on('action.tournament.makePublic', function() {
        toggleTournamentIsPublic($(this).closest('[data-tournament-id]'), true);
    });

    ScoreTrekBattle.Event.on('action.tournament.preset.clone', function() {
        let presetId;

        presetId = (STATUS.form && STATUS.form.controls.presetId) ? STATUS.form.controls.presetId.get() : null;

        if (!presetId) {
            chmDialog.error('error/PRESET_DOES_NOT_EXIST');
            return;
        }

        ScoreTrekBattle.Tournament.Preset.Edit.clone(presetId).then(clonedPresetId => {
            updatePresets(true).then(() => {
                STATUS.form.controls.presetId.set(clonedPresetId).trigger('change');
            });
        });
    });

    ScoreTrekBattle.Event.on('action.tournament.pointsMap.clone', function() {
        let pointsMapId;

        pointsMapId = (STATUS.form && STATUS.form.controls.pointsMapId) ? STATUS.form.controls.pointsMapId.get() : null;

        if (!pointsMapId) {
            chmDialog.error('error/DATA_DOES_NOT_EXIST');
            return;
        }

        ScoreTrekBattle.Tournament.PointsMap.clone(pointsMapId).then(clonedPointsMapId => {
            updatePointsMaps(true).then(() => {
                STATUS.form.controls.pointsMapId.set(clonedPointsMapId).trigger('change');
            });
        });
    });

    ScoreTrekBattle.Event.on('action.tournament.preset.editName', function() {
        let presetId, presetName;

        presetId = (STATUS.form && STATUS.form.controls.presetId) ? STATUS.form.controls.presetId.get() : null;

        if (!presetId) {
            chmDialog.error('error/PRESET_DOES_NOT_EXIST');
            return;
        }

        presetName = STATUS.presets[STATUS.form.controls.presetId.get()].name || null;

        if (!presetName) {
            chmDialog.error('error/PRESET_DOES_NOT_EXIST');
            return;
        }

        ScoreTrekBattle.Tournament.Preset.Edit.rename(presetId, presetName).then(preset => {
            updatePresets(true).then(() => {
                STATUS.form.controls.presetId.set(presetId).trigger('change');
            });
        });
    });

    ScoreTrekBattle.Event.on('action.tournament.pointsMap.editName', function() {
        let pointsMapId, pointsMapName;

        pointsMapId = (STATUS.form && STATUS.form.controls.pointsMapId) ? STATUS.form.controls.pointsMapId.get() : null;

        if (!pointsMapId) {
            chmDialog.error('error/DATA_DOES_NOT_EXIST');
            return;
        }

        pointsMapName = STATUS.pointsMaps[STATUS.form.controls.pointsMapId.get()].name || null;

        if (!pointsMapName) {
            chmDialog.error('error/DATA_DOES_NOT_EXIST');
            return;
        }

        ScoreTrekBattle.Tournament.PointsMap.rename(pointsMapId, pointsMapName).then(pointsMap => {
            updatePointsMaps(true).then(() => {
                STATUS.form.controls.pointsMapId.set(pointsMapId).trigger('change');
            });
        });
    });

    ScoreTrekBattle.Event.on('action.tournament.pointsMap.delete', function() {
        let pointsMapId, pointsMapName;

        pointsMapId = (STATUS.form && STATUS.form.controls.pointsMapId) ? STATUS.form.controls.pointsMapId.get() : null;

        if (!pointsMapId) {
            chmDialog.error('error/DATA_DOES_NOT_EXIST');
            return;
        }

        pointsMapName = STATUS.pointsMaps[STATUS.form.controls.pointsMapId.get()].name || null;

        if (!pointsMapName) {
            chmDialog.error('error/DATA_DOES_NOT_EXIST');
            return;
        }

        chmDialog.confirm(__i18n('dialog/confirm/delete/text', {colorClass: 'color-green', reference: pointsMapName}, true), {
            title: __i18n('dialog/confirm/delete/title'),
            buttonYes: __i18n('button/delete'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            let isCurrent;
        
            isCurrent = (pointsMapId === STATUS.form.controls.pointsMapId.get());

            ScoreTrekBattle.Tournament.PointsMap.delete(pointsMapId).then(() => {
                updatePointsMaps(true).then(() => {
                    if (isCurrent) {
                        STATUS.form.controls.pointsMapId.set('');
                    }
                    STATUS.form.controls.pointsMapId.trigger('change');
                });
            }).catch(ignore => {});
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.tournament.clone', function() {
        var $tournament, tournamentId, tournamentTitle, isListElement;
        $tournament = $(this).closest('[data-tournament-id]');
        isListElement = $tournament.hasClass('tournament-list-item');
        tournamentId = $tournament.attr('data-tournament-id');
        tournamentTitle = $tournament.find('[data-id="tournamentTitle"]').text();
        chmDialog.confirm(__i18n('dialog/confirm/clone/text', {colorClass: 'color-blue', reference: tournamentTitle}, true), {
            title: __i18n('dialog/confirm/clone/title'),
            buttonYes: __i18n('button/clone'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            cloneTournament(tournamentId, isListElement).then(newTournament => {
                ScoreTrekBattle.Tournament.List.add(newTournament, tournamentId);

                if (isListElement) {
                    return;
                }

                ScoreTrekBattle.View.goto(`/tournament/plan/${newTournament.id}`);
            }).catch(ignore => {});
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.tournament.series.add', function() {
        ScoreTrekBattle.Tournament.Series.Edit.add().then(series => {
            ScoreTrekBattle.View.loading('Tournament.Edit.seriesAdd', true);
            updateSeries().then(() => {
                if (STATUS.form) {
                    STATUS.form.controls.seriesId.set(series.id);
                }
            }).catch(ignore => {}).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Edit.seriesAdd', false);
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('preset.updated', function(preset) {
        if (!STATUS.active) {
            return;
        }

        updatePresets(true).then(() => {
            STATUS.form.controls.presetId.set(preset.id).trigger('change');
        });
    });

    ScoreTrekBattle.Event.on('squad.updated', function() {
        var opponentSquadId;

        if (!STATUS.active) {
            return;
        }

        opponentSquadId = STATUS.form.controls.opponentSquadId.get();

        loadOwnSquads().then(() => {
            return loadOpponentSquads(opponentSquadId);
        }).then(() => {
            STATUS.form.controls.opponentSquadId.set(opponentSquadId);
            updateOpponentCustomVisibility(true);
        });
    });

    ScoreTrekBattle.Event.on('pointsMap.updated', function(pointsMap) {
        if (!STATUS.active) {
            return;
        }

        updatePointsMaps(true).then(() => {
            STATUS.form.controls.pointsMapId.set(pointsMap.id).trigger('change');
        });
    });

    return _this;
})();